import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import DataTable from '../../../DataTable';
import Spinner from '../../../Spinner';

@inject("surveyTemplateStore", 'surveyTopicStore')
@observer
class SurveyTemplateList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  componentWillMount() {
    const { surveyTemplateStore, surveyTopicStore } = this.props;
    surveyTemplateStore.fetchItems();
    if (!surveyTopicStore.isLoading && !surveyTopicStore.items.length) surveyTopicStore.fetchItems();
  }

  handleDelete = (idOrIds) => {
    this.props.surveyTemplateStore.removeItems(idOrIds);
  }

  slug = 'monitoring/survey/template';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
  ];

  render() {
    const { surveyTopicStore, surveyTemplateStore, children } = this.props;

    let isLoading = surveyTemplateStore.isLoading || surveyTopicStore.isLoading;

    return (
      <div>
        <DataTable
          data={toJS(surveyTemplateStore.items)}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='maintenance'
        />
        {isLoading && <Spinner />}
        {!isLoading && children}
      </div>
    );
  }
}

export default SurveyTemplateList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/SurveyTemplate/SurveyTemplateList.js